import { ReturnIntegrationProviderSchema } from "@redotech/redo-return-core-common/return-integration-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const monitorSettingSchema = z.object({
  integration: ReturnIntegrationProviderSchema,
  active: z.boolean(),
  minProcessed: z.number().int().min(0),
  minProcessedDays: z.number().int().min(1),
  maxStaleRmas: z.number().int().min(0).nullish(),
});

export type MonitorSetting = z.infer<typeof monitorSettingSchema>;

export const getReturnIntegrationMonitorSettings = unaryRpc({
  name: "getReturnIntegrationMonitorSettings" as const,
  input: z.object({ teamId: z.string().nullish() }),
  output: z.object({ settings: z.array(monitorSettingSchema) }),
});

export type GetReturnIntegrationMonitorSettingsInput = z.infer<
  typeof getReturnIntegrationMonitorSettings.input
>;
export type GetReturnIntegrationMonitorSettingsOutput = z.infer<
  typeof getReturnIntegrationMonitorSettings.output
>;
